const AppConfig = {
  auth: {
    isLoggedIn: 'loggedInLaosExpro',
    accessToken: 'accessTokenLaosExpro',
    userRole: 'userRole',
  }
}

export default AppConfig;
